import Entity from './entity';
export default class ExchangeRate extends Entity<string> {
  currencyId: string;
  rate: number;
  calculatedRate: number;
  date: string;
}
